export enum PaymentAccountStatus {
  Active = 1,
  Pending = 2,
  Suspended = 3,
  Cancelled = 4,
}
